import { formatMoney } from "../../lib/money";

import { LineMiniChart } from "./svgPrimitives";

interface DrawdownPoint {
  trade_date: string;
  drawdown_amount: string;
}

interface DrawdownChartProps {
  points: ReadonlyArray<DrawdownPoint>;
  currency?: string;
  fill?: boolean;
}

export function DrawdownChart({ points, currency = "USD", fill }: DrawdownChartProps) {
  const values = points.map((p) => Number(p.drawdown_amount));
  const labels = points.map((p) => p.trade_date);
  return (
    <LineMiniChart
      values={values}
      testId="drawdown-chart"
      tone="danger"
      labels={labels}
      formatValue={(v) => formatMoney(v.toFixed(2), { currency })}
      fill={fill}
    />
  );
}
